function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.pageDots = this.querySelector('.pageDots');
    var pageDots = document.getElementsByClassName("pageDots");



    for (var i = 0; i < pageDots.length; i++) {
      pageDots[i].addEventListener('click', this.onButtonClick.bind(this),pageDots[i] );
    }
    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    var check = this;


  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    // console.log(33421);
    this.update();
  }

  update() {

    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    var item = $(event.target).attr("data-id");
    // console.log( item);
   // const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left:  this.sliderLastItem.clientWidth*parseInt(item-1)
    });
    $('.pageDots').removeClass('active');
    $(event.target).addClass('active');
  }

  onDotClick(event) {
    event.preventDefault();
    console.log($(this).html());
    var item = $(this).html();
    //const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.sliderLastItem.clientWidth*item
    });

  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // On load disable button
    this.toggleAddButton(true, 'Select Size', false);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" }); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);



class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);




class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);









































// var rebuyBundleTitle = '.rebuy-product-title',
//     splitWords = ' - ';
// watchForElement(rebuyBundleTitle,function(el) {
//   $(rebuyBundleTitle+":contains('"+splitWords+"')").html(function(_, html) {
//     return html.substr(0, html.indexOf(splitWords));
//   });
// })

waitForSlider(function () {

  $(".lazy").slick({
    lazyLoad: 'ondemand', // ondemand progressive anticipated
    infinite: true
  });

  if ($('.js-gallery').length) {
    var $carousel = $('.gallery__images, .gallery-grid__images').slick({arrows: false, dots: true, infinite: true, fade: true, touchThreshold: 10});
    var $gridButtons = $('.js-gallery-thumb');
    $('.gallery__images, .gallery-grid__images').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $gridButtons.removeClass('is-selected');
      $gridButtons.eq(nextSlide).addClass('is-selected');
      $('.img').removeClass('is-selected');
      $('.slick-slide').eq(nextSlide).find('.img').addClass('is-selected');
    });
    $gridButtons.on('click', function (e) {
      e.preventDefault();
      var index = $(this).data('thumbId');
      $carousel.slick('slickGoTo', index);
    });
  }

})

waitForJquery(function() {






  var parent          = '.gallery-grid .slick-slide > div',
      child           = '.img',
      zoomClass       = 'zoom',
      cursorZoomIn    = 'zoom-in',
      cursorZoomOut   = 'zoom-out',
      logs            = false,
      childZoom      = child+'.'+zoomClass;

  function zoomIn(el) {
    element = { width: el.width(), height: el.height() };
    scale = 2;
    ratio = scale * 0.25;
    mouse = { x: event.pageX, y: event.pageY };
    offset = el.offset();
    origin = { x: (offset.left + (element.width * ratio)), y: (offset.top + (element.height * ratio)) };
    trans = { left: (origin.x - mouse.x) * ratio, down: (origin.y - mouse.y) * ratio };
    transform = ("scale(" + scale + ',' + scale + ") translateX(" + trans.left + "px) translateY(" + trans.down + "px)");
  }
  $(document).on('click', parent, function() {
    if (!scrnSze('mob')) {
      var el = $(this);
      if (el.find(child).is('.' + zoomClass)) {
        el.css('cursor', cursorZoomIn).find(child).removeClass(zoomClass).css("transform", 'none');
        if (logs == true) { console.log('Zoom Off.') }
      } else {
        zoomIn(el);
        $(this).css('cursor', cursorZoomOut).find(child).addClass(zoomClass).css("transform", transform);
        if (logs == true) { console.log('Zoom On.') }
      }
    }
  });
  $(document).on('mousemove', parent, function() {
    if (!scrnSze('mob')) {
      var el = $(this);
      zoomIn(el);
      el.find(childZoom).css("transform", transform);
      if (logs == true) { console.log('Zoooooming') }
    }
  });
  $(document).on('mouseleave', parent, function() {
    if (!scrnSze('mob')) {
      var el = $(this);
      el.css('cursor', cursorZoomIn).find(childZoom).css("transform", "none").removeClass(zoomClass);
      if (logs == true) { console.log('All Regular Sized') }
    }
  });

  var user_keys = [], konami = '38,38,40,40,37,39,37,39,66,65';
  document.onkeydown = function (e) {
    user_keys.push(e.keyCode);
    if (user_keys.toString().indexOf(konami) >= 0) {
      alert('UNLOCKED! You are now invincible. (cheater!)');
      user_keys = [];
    }
  }

  function scrnSze(set) {
    var winWth = $(window).width(), set = !!set ? set : 'am i defined?', mob = 'mob', tab = 'tab', dsk = 'dsk',
        mobSze = winWth < 750, dskSze = winWth >= 990, tabSze = winWth >= 750 && !dskSze;
    if (mobSze && !set || mobSze && set == mob) {
        return !set ? mob : true;
    } else if (!mobSze && set == mob) {
        return false
    }
    if (tabSze && !set || tabSze && set == tab) {
        return !set ? tab : true;
    } else if (!tabSze && set == tab) {
        return false
    }
    if (dskSze && !set || dskSze && set == dsk) {
        return !set ? dsk : true;
    } else if (!dskSze && set == dsk) {
        return false
    }
  }


  jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector) {
      return $(el).is('a, button, :input, label, [tabindex]');
    }
  });


  // Accordian
  $('#tabs-select').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      // window.location = url; // redirect
      $('a[href="' + url + '"]').trigger('click');
    }
    return false;
  });

  // sidebar links
  $('.accordion-section .sidebar-link').on('click  touch', function() {
    // body...
    $('.accordion-section .sidebar-link').removeClass('active');
    $(this).addClass('active');
  })
  // Accordian
  $(document).on('touch click', '.acc-btn', function() {
    var btn = '.acc-btn',
      animTime = 300,
      justClickedDelay = 500,
      justClicked = false,
      active = 'selected',
      cont = '.acc-content',
      ttlTxt = 'h3',
      imgItm = '.img',
      clckdIndx = $(this).index(btn),
      inrChldHght = $(cont).children().eq(clckdIndx).outerHeight(),
      $thsTtl = $(this).find(ttlTxt),
      $thsImg = $(this).find(imgItm),
      isOpen = $thsTtl.hasClass(active),
      winWidth = $(window).width(),
      clearItem = $('#shopify-section-header'),
      actTab = $(ttlTxt + '.' + active),
      actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;
    if (!!clearItem && !!actTab) {
      actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
    }
    if (!justClicked) {
      justClicked = true;
      if (isOpen) {
        removeClasses();
        openClose();
        // console.log('close')
      } else {
        // console.log('open')
        removeClasses();
        addClasses();
        openClose(true);
        // mobScroll();
      }
      setTimeout(function() { justClicked = false; }, justClickedDelay);
    }

    function mobScroll() {
      if (winWidth < 750) {
        setTimeout(function() {
          console.log(openTabDist)
          $([document.documentElement, document.body]).animate({
            scrollTop: openTabDist
          }, animTime);
        }, animTime * 2.5);
      }
    }

    function removeClasses() {
      $(btn + ' ' + ttlTxt).removeClass(active);
      $(btn + ' ' + imgItm).removeClass(active);
    }

    function addClasses() {
      $thsTtl.addClass(active);
      $thsImg.addClass(active);
    }

    function zeroHght() {
      $(cont).stop().animate({ height: 0 }, animTime);
    }

    function setHght() {
      $(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
    }

    function openClose(dir) {
      if (dir == 'open' || dir == true) {
        zeroHght()
        setHght()
      } else {
        setHght()
        zeroHght()
      }
    }
  });






  // on load
  thisHash = window.location.hash
  // removes hash from href
  // history.pushState(thisHash, '', window.location.pathname);
  if (thisHash.length > 0) {
    setTimeout(function() {
      clearThis = $('#shopify-section-header').height() + 25;
      $('html, body').animate({
        scrollTop: $(thisHash).offset().top - clearThis
      }, 1000);
    }, 200)
  }
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#recover"]')
    .not('[href="#login"]')
    .not('[href="#0"]')
    .click(function(event) {
      // Clear whatever is at top of page, usually the header
      clearThis = $('#shopify-section-header').height() + 25;
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - clearThis
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });


    $('a')
      .not('#boldmetrics-ssc-activator')
      .not('.img-tab-link-2') // .not() ignores anchors with this class
      .not('[href*="tel:"]')
      .not('[href*="mailto:"]')
      .not('.product-single__thumbnail')
      .each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
          $(this).click(function(event) { 
            if ( !$(this).is('#boldmetrics-ssc-activator') ) {
              event.preventDefault();
              event.stopPropagation();
              window.open(this.href, '_blank');
            }
          });
        }
      });

    $('#boldmetrics-ssc-activator').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
      });


  // show/hide back to top
  backToTop()

  $(document).scroll(function() {
    backToTop()
  });
  $(document).resize(function() {
    backToTop()
  });

  function backToTop() {
    var topBtn = $('.back-to-top'),
      act = 'show-top',
      fromTop = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop,
      minDist = window.innerHeight * 0.75;
    if (fromTop > minDist) {
      topBtn.addClass(act)
    } else {
      topBtn.removeClass(act)
    }
  }



  $('.js-filters-toggle').click(function (e) {
    $('html').toggleClass('filters-is-open');
    e.preventDefault();
  });



  function Modal(el) {
    el = el;
    act = 'active';
    actMod = 'modal-active';
    initMdl(el)

    function initMdl(el) {
      winWidth = $(window).width();
      thisEl = el;
      type = getDataName($(thisEl)).length ? getDataName($(thisEl)) : 'modal';
      thisMdl = getDataName($(thisEl)).length ? $('[data-modal="' + $(thisEl).data(type) + '"]') : $(thisEl);
      if (type == 'open' || type == 'modal') {
        if (!thisMdl.is('.' + act)) {
          showModal(thisMdl);
        } else {
          hideModal(thisMdl);
        }
      }
      if (type == 'close') {
        hideModal(thisMdl);
      }
    }

    function showModal(el) {
      var lastTop = $(window).scrollTop(),
        el = $(el),
        delay = 0;
      $('body').addClass(actMod).css({ top: -lastTop });
      if (el.is('[style*=display]')) {
        el[0].removeAttribute('style');
        delay = 100; // gives a moment for animation settings to take over
      }
      setTimeout(function() {
        el.addClass(act);
        el.find(':focusable').first().focus();
      }, delay)
    }

    function hideModal(el) {
      var lastTop = Math.abs(parseInt($('body').css('top'))),
        el = $(el);
      $('body').css({ top: 0 }).removeClass(actMod);
      window.scrollTo(0, lastTop);
      el.removeClass(act);
    }

    function getDataName(node) {
      var d = {},
        key = '',
        re_dataAttr = /^data\-(.+)$/;
      $.each(node.get(0).attributes, function(index, attr) {
        if (re_dataAttr.test(attr.nodeName)) {
          key = attr.nodeName.match(re_dataAttr)[1];
        }
      });
      return key;
    }
  }

  $(document).ready(function() {
    $('.modal-action').on('click touch', function() {
      Modal($(this));
      // console.log($(this))

      var vid = $(this).closest('.video-modal').find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })


    $('.btn-modal').on('click touch', function() {

      var thsId = $(this).attr('href');

      Modal($(thsId));
      // console.log($(thsId))

      var vid = $(thsId).find('iframe');
      if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
        var vidSrc = vid.attr('src');
        // console.log(vidSrc)
        vid.attr('src', vidSrc);
      }
    })
  })

  // videoRatio()

  // function videoRatio() {
  //   var vid = $('.video-ratio iframe,.video-ratio video');

  //   initRatio();
  //   $(window).resize(function() {
  //     initRatio();
  //   })

  //   function initRatio() {
  //     var winWdth = $(window).width(),
  //       ratio = 0.56;

  //     if (vid.length) {
  //       vid.each(function() {
  //         var thsVid = $(this);

  //         if (typeof thsVid.data('video-ratio') !== 'undefined') {
  //           var ratio = thsVid.data('video-ratio');
  //         }
  //         var thsVidPar = thsVid.closest('div'),
  //           thsVidParHght = thsVidPar.outerHeight(true),
  //           cssHght = thsVidParHght,
  //           cssWdth = cssHght / ratio;

  //         if (cssWdth < winWdth) {
  //           var cssWdth = winWdth,
  //             cssHght = cssWdth * ratio;
  //         }

  //         thsVid.attr('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')

  //       })
  //     }
  //   }
  // }




  // New Navigation 
  $(document).ready(function() {
    var mega, drp, prvFxdHdrHght, prevDistFromTop;
    var winWdth = $(window).width(),
      distFromTop = document.documentElement.scrollTop,
      prevdistFromTop = distFromTop,
      mobInit = 992,
      isDesk = winWdth >= mobInit,
      justClicked = false,
      fxdHdr = 'header.header',
      fxdHdrHght = $(fxdHdr).height(),
      mnCntnt = '#MainContent',
      lnk = '.nav-item',
      inrLnk = '.dropdown-link',
      drpDwn = '.dropdown-list',
      nulLnk = 'a[href="#"]',
      megaMenu = '.mega-pane',
      megaDta = 'megamenu',
      drpActive = 'active',
      bdyCls = 'mega-menu--locked',
      inr = 'inner-',
      otrItmDta = 'nav-item',
      inrItmDta = inr + otrItmDta,
      otrDrpDta = 'dropdown',
      inrDrpDta = inr + otrDrpDta,
      mobNav = '.mobile-nav',
      openCloseMobNav = '.menu-btn,.close-nav',
      mobNavOpen = 'mobile-nav-open',
      navOpen = 'mobile-nav--open',
      navClose = 'mobile-nav--close',
      mobNavBG = '.mobile-nav-background-close',
      moveAside = '.move-aside',
      mobDrpTggl = '.menu-toggle',
      mobBckTggl = '.reverse',
      lvlOne = 'level-one',
      lvlTwo = 'level-two';

    function clickPolice(justClicked) {
      // console.log('clickPolice')
      // justClicked = true;
      // setTimeout(function() { justClicked = false;
      //   console.log(justClicked) }, 700);
    }

    initNav(mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt)
    $(window).resize(function() {
      initNav(mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt)
    })
    $(window).scroll(function() {
      initNav(mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt)
      closeMega()
    })

    function initNav(mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt) {
      var winWdth = $(window).width(),
        fxdHdrHght = $(fxdHdr).height(),
        isDesk = winWdth >= mobInit;

      // This is needed to prevent mobile menu from being buggy. 
      $(lnk+','+inrLnk+','+megaMenu+','+drpDwn+',' +mobDrpTggl+','+lnk+' '+nulLnk+','+inrLnk+' '+nulLnk+','+openCloseMobNav+','+mobNavBG).off();


      if (prvFxdHdrHght != fxdHdrHght) {
        // $(megaMenu).css({
        //   top: fxdHdrHght
        // });
        var prvFxdHdrHght = fxdHdrHght;
      }
      if (isDesk == true) {
        $(lnk + ',' + inrLnk).off().on('mouseover mouseleave focusin focusout', function(e) {
          if (!justClicked && isDesk) {
            clickPolice()

            if (e.type == 'mouseover' || e.type == 'focusin') {
              openLinks($(this))
            }
            if (e.type == 'mouseleave') {
              closeLinks($(this))
            }
            if (e.type == 'focusout') {
              fcsChkr($(this))
            }
          }
        })
        $(megaMenu + ',' + drpDwn).off().on('mouseleave focusout', function(e) {
          if (!justClicked && isDesk) {
            clickPolice()

            if (e.type == 'mouseleave' && $(this).is(megaMenu)) {
              closeMega($(this))
            }
            if (e.type == 'focusout' && $(this).is(megaMenu)) {
              fcsChkr($(this))
            }
            if (e.type == 'mouseleave' && $(this).is(drpDwn)) {
              closeLinks($(this))
            }
          }
        })
      } else {
        $(mobDrpTggl + ',' + lnk + ' ' + nulLnk + ',' + inrLnk + ' ' + nulLnk).off().on('touch click', function(e) {
          if (!justClicked && !isDesk) {
            clickPolice()


            // If arrow click
            if ($(this).is(mobDrpTggl)) {
              ths = $(this);
            }
            // if null link ('#' as href)
            if ($(this).is(nulLnk)) {
              e.preventDefault();
              ths = $(this).parent().children(mobDrpTggl);
            }
            openMobLnk(ths)


          }
        })
        $(openCloseMobNav + ',' + mobNavBG).off().on('touch click', function(e) {
          e.preventDefault();
          if (!justClicked && !isDesk) {
            clickPolice()

            toggleMobNav()
          }
        })
      }

    }

    function openLinks(el) {
      var $thsLnk = $(el),
        isAct = $thsLnk.is('.' + drpActive),
        otrData = $thsLnk.data(otrItmDta),
        inrData = $thsLnk.data(inrItmDta);
      if (!!otrData || !!inrData) {
        closeLinks($thsLnk)
      }
      if (!isAct) {
        $thsLnk.addClass(drpActive);
        // Activate Megamenu
        var mega = $('[data-' + megaDta + '="' + otrData + '"]');
        if (!!mega) {
          fxdHdrHght = $(fxdHdr).height();
          mega
            // .css({top: fxdHdrHght})
            .addClass(drpActive);
        }
      }
    }

    function closeLinks(el) {
      var $thsLnk = $(el),
        otrData = $thsLnk.data(otrItmDta),
        inrAct = $thsLnk.is('.' + drpActive),
        megaAct = $('[data-' + megaDta + '="' + otrData + '"]').is('.' + drpActive);
      if (!megaAct && !inrAct) {
        $(drpDwn + ',' + megaMenu + ',' + lnk + ',' + inrLnk).removeClass(drpActive);
      }
    }

    function closeMega(el) {
      $(drpDwn + ',' + megaMenu).removeClass(drpActive);
      $(lnk).removeClass(drpActive);
    }

    function toggleMobNav(el) {
      var isAct = $(mobNav).is('.' + drpActive);
      if (!isAct) {
        lockBody()
        var distFromTop = document.documentElement.scrollTop;
        // make nav active
        $(mobNav + ',' + mobNavBG).addClass(drpActive);
        $(openCloseMobNav).addClass(navClose).removeClass(navOpen);
        // $('body').css('top', -(distFromTop) + 'px').addClass(bdyCls);
        $(fxdHdr).addClass(mobNavOpen);
      } else {
        unlockBody()

        $(openCloseMobNav).removeClass(navClose).addClass(navOpen);
        // remove active from menu and bg-overlay/close
        $(mobNav + ',' + mobNavBG).removeClass(drpActive);
        // remove all active classes to reset menu
        $(mobNav + ' .' + drpActive).removeClass(drpActive);
        // remove level classes from the move aside element
        $(moveAside).removeClass(lvlOne).removeClass(lvlTwo);
        // $('body').removeClass(bdyCls);
        // $(window).scrollTop(prevDistFromTop);
        $(fxdHdr).removeClass(mobNavOpen);
      }
      prevDistFromTop = distFromTop;
    }

    function openMobLnk(el) {
      var $thsLnk = $(el),
        isDrpTggl = $thsLnk.is(mobDrpTggl),
        isBckTggl = $thsLnk.is(mobBckTggl),
        $thsPar = $thsLnk.parent(),
        isAct = $thsPar.is('.' + drpActive),
        moveLvlOne = $(moveAside).is('.' + lvlOne),
        moveLvlTwo = $(moveAside).is('.' + lvlTwo);
      // Move to Second Level
      if (!moveLvlOne && $thsPar.is(lnk)) {
        remActive($thsPar)
        addActive($thsPar)
        togLvl(moveAside, lvlOne)
      }
      // Move to Third level
      if (!moveLvlTwo && $thsPar.is(inrLnk)) {
        remActive($thsPar)
        addActive($thsPar)
        togLvl(moveAside, lvlTwo)
      }
      // Move back to Second level
      if (moveLvlTwo && moveLvlOne && isBckTggl) {
        togLvl(moveAside, lvlTwo)
        remActive($thsPar)
      }
      // Move back to First level
      else if (moveLvlOne && isBckTggl) {
        togLvl(moveAside, lvlOne)
        remActive($thsPar)
      }

      function remActive(el) {
        setTimeout(function() {
          $thsPar.parent().children().removeClass(drpActive)
        }, 200)
      }

      function addActive(el) {
        setTimeout(function() {
          $thsPar.addClass(drpActive);
        }, 200)
      }

      function togLvl(el, cls) {
        setTimeout(function() {
          if ($(el).is('.' + cls)) {
            $(el).removeClass(cls)
          } else {
            $(el).addClass(cls);
          }
        }, 200)
      }
    }

    function lockBody() {
      var lastTop = $(window).scrollTop();
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').addClass(bdyCls).css({ top: -lastTop });
      if ( isIOS ) {
        var hght = window.innerHeight - 1;
        console.log(hght)
        console.log(hght+1)
      }
    }
    function unlockBody(el) {
      var lastTop = Math.abs(parseInt($('body').css('top')));
      var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      $('body').css({ top:0}).removeClass(bdyCls);
      window.scrollTo(0, lastTop);
      if ( isIOS ) {
        $('body')[0].style.removeProperty('height');
      }
    }

    function fcsChkr(el) {
      var $thsLnk = $(el);
      checker = setTimeout(function() {
        if (!$thsLnk.find(':focus').length) {
          closeLinks($thsLnk);
        }
      }, 0);
      clearTimeout(checker)
    }
  });

});













var globalJSisLoaded = true;